import { render } from "./Ponentes.vue?vue&type=template&id=04b28d48"
import script from "./Ponentes.vue?vue&type=script&lang=js"
export * from "./Ponentes.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/congreso_online/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__